import React from 'react'
import './CompStructure.css'

const CompStructure = ({ compData }) => {
    return (
        <div className="app__table_comp">
             <h2 className="comp__table-header">OSUSC COMPETITIVE STRUCTURE - ILLOWA LEAGUE & TOURNAMENTS</h2>
            <table className="app__background-bk comp__table ">
                <thead className="comp__table_thead">
                    <tr className="comp__tr">
                        <th className="h4__roboto comp__th">Age Group</th>
                        <th className="h4__roboto comp__th">Match Length</th>
                        <th className="h4__roboto comp__th">Ball Size</th>
                        <th className="h4__roboto comp__th">Team Size</th>
                        <th className="h4__roboto comp__th">Offsides Rule</th>
                        <th className="h4__roboto comp__th">Headers</th>
                    </tr>
                </thead>
                <tbody className="comp__tbody">
                    {compData.map((row, index) => (
                        <tr className="comp__tr" key={index}>
                            <td className="cData">{row.age}</td>
                            <td className="cData">{row.matchLength}</td>
                            <td className="cData">{row.ballSize}</td>
                            <td className="cData">{row.teamSize}</td>
                            <td className="cData">{row.offsideRule}</td>
                            <td className="cData">{row.headers}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default CompStructure